import client from './client';

export const createChallenge = async (data) => {
    const response = await client.post('/challenges', data);
    return response.data;
};

export const updateChallenge = async (challengeId, data) => {
    const response = await client.put(`/challenges/${challengeId}`, data);
    return response.data;
};

export const promoteParticipant = async (challengeId, userId) => {
    const response = await client.put(`/challenges/${challengeId}/promote`, { user_id: userId });
    return response.data;
};

export const getChallengeDetails = async (challengeId) => {
    const response = await client.get(`/challenges/${challengeId}`);
    return response.data;
};

export const getManagedChallenges = async () => {
    const response = await client.get('/challenges/managed');
    return response.data;
};

export const getParticipatingChallenges = async () => {
    const response = await client.get('/challenges/participating');
    return response.data;
};

export const searchChallenges = async (query) => {
    const params = query ? { q: query } : {};
    const response = await client.get('/challenges/search', { params });
    return response.data;
};

export const getTopPublicChallenges = async (offset = 0) => {
    const response = await client.get('/challenges/top-public', { params: { offset } });
    return response.data;
};

export const joinChallenge = async (challengeId) => {
    const response = await client.post(`/challenges/${challengeId}/join`, {});
    return response.data;
};

export const leaveChallenge = async (challengeId) => {
    const response = await client.delete(`/challenges/${challengeId}/leave`);
    return response.data;
};

export const endChallenge = async (challengeId) => {
    const response = await client.put(`/challenges/${challengeId}/end`, {});
    return response.data;
};

export const restartChallenge = async (challengeId) => {
    const response = await client.put(`/challenges/${challengeId}/restart`, {});
    return response.data;
};

export const getRecurrenceHistory = async (challengeId) => {
    const response = await client.get(`/challenges/${challengeId}/recurrences`);
    return response.data;
};

export const inviteToChallenge = async (challengeId, inviteeId) => {
    const response = await client.post(`/challenges/${challengeId}/invite`, { invitee_id: inviteeId });
    return response.data;
};

export const getChallengeInvites = async () => {
    const response = await client.get('/challenges/invites');
    return response.data;
};

export const respondChallengeInvite = async (challengeId, status) => {
    const response = await client.post(`/challenges/${challengeId}/invite/respond`, { status });
    return response.data;
};

export const getInvitableFriends = async (challengeId) => {
    const response = await client.get(`/challenges/${challengeId}/invitable-friends`);
    return response.data;
};
